import { render, staticRenderFns } from "./FormEditarColaborador.vue?vue&type=template&id=26490929"
import script from "./FormEditarColaborador.vue?vue&type=script&lang=js"
export * from "./FormEditarColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports